export default __webpack_public_path__ + "static/media/icon-adresse.bb3c3726.svg";